import { Flex } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";
import utils from "utils";

const headers = [
  {
    label: "Limit",
    colW: "12ch",
    style: {
      textAlign: "end",
      // width: '11ch',
    },
  },
  "",
];

function ClaimLimits() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);

  const navigate = useNavigate();

  const onNew = async () => {
    navigate("/claimlimitsmanage", {
      state: {
        action: "claimlimits-add",
        data: {},
      },
    });
  };

  const getList = async (data) => {
    setIsLoading(true);

    return api
      .getPurchaselimit({
        page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);

        if (res?.status === 200) {
          console.log(res.data);
          if (data?.page) {
            setActivePage(data.page);
          }

          if (res?.data && res?.data[0]?.purchaselimitid) {
            const l = res.data.map((item) => ({
              id: item?.purchaselimitid,
              purchaselimitamount: utils.formatAmountForTb(
                item?.purchaselimitamount
              ),
              space: " ",
              data: item,
            }));
            setList(l);
          } else {
            setList([]);
          }
        } else {
          setList([]);

          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onSelectItm = (data) => {
    console.log("selected item d id =", data?.item?.data?.purchaselimitamount);

    // setSelectedItem(data);
    // setPurchaselimitamount(data?.item?.data?.purchaselimitamount || 0);
    // setDurationvalue(data?.item?.data?.durationvalue);

    navigate("/claimlimitsmanage", {
      state: {
        action: "claimlimits-edit",
        data: data?.item?.data,
      },
    });
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
    });
  };

  useEffect(() => {
    const cb = async () => {
      await getList();
    };
    cb();
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Claim Limits"} isLoading={isLoading} />
      <Flex wrap={"wrap"} justifyContent="flex-end" gap={"1rem"} mb={"1rem"}>
        {/* <Flex flex={1} /> */}
        {/* <InputComp
          type={"number"}
          placeholder={"Amount"}
          value={purchaselimitamount}
          onChange={setPurchaselimitamount}
        /> */}
        {/* <ButtonComp
          label="Open"
          keyname="open"
          onClick={onOpen}
          disabled={!selectedItem}
        /> */}
        {/* <Button variant="outline" onClick={onSave} disabled={!selectedItem}>
          Save
        </Button> */}
        <ButtonComp
          label="New"
          keyname="new"
          onClick={onNew}
          // disabled={!purchaselimitamount}
        />
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        // selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default ClaimLimits;
